import React from 'react'
import Nav from './components/nav'
import HeroSection from './components/hero-section'
import AboutSection from './components/about-section'
import RegistrationSection from './components/registration'
import Resources from './components/resources'
import Schedule from './components/schedule'
import Countdown from './components/countdown'
import BannerSection from './components/banner'
import Footer from './components/footer'
import { Helmet } from 'react-helmet'

const NewConferencePage = () => {
  return (
    <div>
       <Helmet>
            <title>Register for UBF Easter Conference 2025</title>
            <meta name="description" content="Join us for an amazing time in God's presence!" />
        </Helmet>
        <Nav />
        <HeroSection />
        <Countdown />
        <AboutSection />
        <RegistrationSection />
        <Resources />
        <Schedule />
        <BannerSection />
        <Footer />
    </div>
  )
}

export default NewConferencePage